'use client';

import {Accordion} from '@web-landing/components/Accordion';

import {TAutoupdatePage} from '@web-landing/strapi/types';

import styles from './AutoupdateFAQ.module.scss';

type Props = Pick<TAutoupdatePage, 'faq_title' | 'faq_items'>;

export const AutoupdateFAQ = ({faq_items, faq_title}: Props) => {
  if (!faq_items?.length) return null;

  return (
    <div className={styles.faq}>
      <h2 className={styles.faq__title}>{faq_title}</h2>
      <div className={styles.faq__items}>
        {faq_items?.map((item, index) => (
          <Accordion
            key={index}
            title={item.title}
            content={item.description}
            opened={!index}
          />
        ))}
      </div>
    </div>
  );
};
